import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'state_rate_settings',
  inputShow: gql`
    query stateRateSettings($input: StateRateSettingQueryInput) {
      stateRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'State Rate Settings',
    order: 7,
  },
};
